import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature
        title="About Us"
        text="We’re a team of multi-disciplinary brand strategists, visual storytellers, copy fanatics and digital natives, passionate about creating brands that stand out, and stand for something.

"
      />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">
        We prvide expert services
      </h1>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature
        title="Concept Testing"
      />
      <Feature
        title="Brand Positioning"
      />
      <Feature
        title="Tagline Development"
      />
      <Feature
        title="Brand Launch strategy"
      />
      <Feature
        title="Branded Content"
      />
      <Feature
        title="Marketing Collateral"
      />
      <Feature
        title="Logo Design"
      />
      <Feature
        title=" Video Production"
      />
    </div>
  </div>
);

export default WhatGPT3;
